/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeUpdateServiceProviderSettingsPayoutDetailsCommand, type ProblemDetails, type UpdateServiceProviderSettingsPayoutDetailsCommand } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /serviceprovidersettings/payout-details
 */
export interface PayoutDetailsRequestBuilder extends BaseRequestBuilder<PayoutDetailsRequestBuilder> {
    /**
     * UpdateServiceProviderSettingsPayoutDetails
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateServiceProviderSettingsPayoutDetailsCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * UpdateServiceProviderSettingsPayoutDetails
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateServiceProviderSettingsPayoutDetailsCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PayoutDetailsRequestBuilderUriTemplate = "{+baseurl}/serviceprovidersettings/payout-details";
/**
 * Metadata for all the requests in the request builder.
 */
export const PayoutDetailsRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: PayoutDetailsRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateServiceProviderSettingsPayoutDetailsCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
